/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'more': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h24v24H0z"/><path pid="1" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" _fill="#004CD0" fill-rule="nonzero"/></g>'
  }
})
